import { cdmMw } from "../api";

export const broadcastMessageUserResource = {
    api: cdmMw,
    url: () => '/api/createMessageUser',
    parseResponse: ({data}) => data,
    defaultValue: []
};